import Icon from '../components/Icon.vue'

Icon.register({"pound-sign":{"width":320,"height":512,"paths":[{"d":"M308 352H262.5C255.9 352 250.5 357.4 250.5 364V414.8H128V288H212C218.6 288 224 282.6 224 276V236C224 229.4 218.6 224 212 224H128V160.4C128 128.2 152.6 103.4 189.8 103.4 213.4 103.4 235.7 114.9 247.4 122.2 252.6 125.4 259.3 124.3 263.1 119.5L291.6 84C295.9 78.7 294.9 71 289.5 66.9 273.1 54.6 236.6 32 187.9 32 106 32 48 84.7 48 158V224H20C13.4 224 8 229.4 8 236V276C8 282.6 13.4 288 20 288H48V416H12C5.4 416 0 421.4 0 428V468C0 474.6 5.4 480 12 480H308C314.6 480 320 474.6 320 468V364C320 357.4 314.6 352 308 352z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/pound-sign.js
// module id = null
// module chunks = 